import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
  TextField,
  Typography,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

import { useCommentDialog } from './useCommentDialog';

interface CommentDialogProps {
  open: boolean;
  onClose: () => void;
  eventId: string;
  userId: string;
  defaultOrgaComment: string;
}

export const CommentDialog: FunctionComponent<CommentDialogProps> = ({
  open,
  onClose,
  eventId,
  userId,
  defaultOrgaComment,
}) => {
  const { onSubmit, register, errors } = useCommentDialog({
    eventId,
    userId,
    onClose,
    defaultOrgaComment,
  });
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Modifier le commentaire</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="orgaComment"
          label="Commentaire de l'orga"
          type="text"
          fullWidth
          {...register('orgaComment')}
          helperText={
            errors.orgaComment?.message ? (
              <Typography component="p" variant="body2" color="error.main">
                {errors.orgaComment.message}
              </Typography>
            ) : null
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={onSubmit}>Valider</Button>
      </DialogActions>
    </MuiDialog>
  );
};
